import { render, staticRenderFns } from "./SearchDataStudio.vue?vue&type=template&id=842c7bd0&scoped=true&lang=pug"
import script from "./SearchDataStudio.vue?vue&type=script&lang=js"
export * from "./SearchDataStudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842c7bd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('842c7bd0')) {
      api.createRecord('842c7bd0', component.options)
    } else {
      api.reload('842c7bd0', component.options)
    }
    module.hot.accept("./SearchDataStudio.vue?vue&type=template&id=842c7bd0&scoped=true&lang=pug", function () {
      api.rerender('842c7bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SearchDataStudio.vue"
export default component.exports